//write a function to pad input number with leading zeros
export const padNumber = (num: number, size: number) => {
  var s = num + '';
  while (s.length < size) s = '0' + s;
  return s;
};
